import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import React from 'react';

type SeoReviewProps = Readonly<{
  name: string;
  location: string;
  content: string;
}>;

const SeoReview: React.FC<SeoReviewProps> = ({ name, location, content }) => {
  return (
    <Box
      display="grid"
      gap={4}
    >
      <Flex
        gap={4}
        alignItems="center"
      >
        <TextV2 fontWeight={600}>{name}</TextV2>
        <TextV2 fontStyle="italic">{location}</TextV2>
        <Box>
          <TextV2 color="#f5c518">★★★★★</TextV2>
        </Box>
      </Flex>
      <TextV2>{content}</TextV2>
    </Box>
  );
};

const SeoReviewsList: React.FC = ({ children }) => {
  return (
    <Box
      width="100%"
      maxWidth={pxToRem(1248)}
      paddingX={6}
      paddingTop={10}
      paddingBottom={0}
      marginX="auto"
      display="grid"
      gap={8}
    >
      {children}
    </Box>
  );
};

type SeoReviewsSectionProps = Readonly<{
  category: StationeryTemplateCategoryEnum;
}>;

export const SeoReviewsSection: React.FC<SeoReviewsSectionProps> = ({ category }) => {
  const { tq } = useTranslation('stationery');

  if (category === StationeryTemplateCategoryEnum.saveTheDate) {
    return (
      <SeoReviewsList>
        <SeoReview
          name={tq`Alex & Zack`}
          location={tq`Brooklyn, NY`}
          content={tq`Just wanted to follow up to thank the entire team for creating the most beautiful save the dates! We put them in the mail yesterday and they looked amazing. I don't have Reddit, but I've been telling all my friends how amazing things turned out and how great the customer service is.`}
        />
        <SeoReview
          name={tq`Sophia & Jimmy`}
          location={tq`Pasadena, CA`}
          content={tq`The card team from Joy is incredible! When our initial Thank You card order was not what we expected, we communicated our concerns with the team. The team worked with us daily to reach a resolution that not only worked but exceeded our expectations. We are so grateful to have worked with the card team to put a beautiful bow of thanks on our wedding.`}
        />
        <SeoReview
          name={tq`Guadalupe & Andy`}
          location={tq`Chicago, IL`}
          content={tq`We chose Joy for our destination wedding because it was super easy to use and offered all the features we needed. Planning a wedding away from home was a big task, but Joy made it a easy! Our favorite features were definitely the guest list and schedule options – they kept us on track and stress-free!`}
        />
      </SeoReviewsList>
    );
  }

  return null;
};
